<template>
  <div id="contenedor-agregar-catalogo-colonias">
    <v-form v-model="formularioValido" ref="registrarCatalogoColonia">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar nueva Colonia
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            label="Localidad"
            v-model="catalogoColonia.idLocalidad"
            :items="listadoLocalidades"
            item-text="descripcion"
            item-value="id"
            :rules="[mixReglas.requerido]"
            required
          />
          <custom-text-field
            label="Nombre de la Colonia"
            v-model="catalogoColonia.descripcion"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="guardar"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import mixCatalogoColonias from './mixCatalogoColonias';
import mixCatalogoLocalidades from '../localidades/mixCatalogoLocalidades';

export default {
  name: 'AgregarCatalogoColonias',
  mixins: [mixCatalogoColonias, mixCatalogoLocalidades],
  components: {
    CustomButton,
    CustomTextField,
    CustomSelect,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      catalogoColonia: {
        idLocalidad: '',
        descripcion: '',
      },
    };
  },
  methods: {
    async guardar() {
      await this.mixAgregarCatalogoColonia().then(() => {
        this.catalogoColonia = {
          idLocalidad: '',
          descripcion: '',
        };
        this.cerrar();
      });
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
  computed: {
    listadoLocalidades() {
      if (!this.catalogoLocalidades) {
        return [];
      }
      return this.catalogoLocalidades;
    },
  },
};
</script>

<style lang="scss">

</style>
